export const API = "https://staging.sabrecwa.com/staff";
// export const API_Local = "http://localhost:7000";
// export const API_Local = "https://m6hsr3z5-7000.uks1.devtunnels.ms";
export const API_Local = "https://portal.sabrecwa.com/backend";
